import React, { useState } from "react";
import PrimaryButton from "./PrimaryButton";
import CopyModal from "../modals/CopyModal";

/**
 * designBox permet de savoir si on doit gérer l'affichage pour les "box" des codes immeubles dans 
 * les infos de la résidence
 * @param {*} param0 
 * @returns 
 */
const ShareButton = ({ text, designBox = true }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShare = async (event) => {
    event.preventDefault();

    try {
      await navigator.clipboard.writeText(text);
      setShowModal(true);
    } catch (error) {
      console.error("Erreur lors de la copie du texte :", error);
    }
  };

  return (
    <>
      {designBox ? (
        <div className="flex justify-center mt-4">
          <button
            onClick={handleShare}
            className="bg-white text-primary font-bold py-2 px-4 rounded-lg shadow-lg hover:bg-gray-200 transition"
          >
            Partager
          </button>
        </div>
      ) : (
        <a href="#" onClick={handleShare} className="justify-end flex mb-4">
          <PrimaryButton type={"button"} value={"Partager"} loading={false} />
        </a>
      )}

      {showModal && (
        <CopyModal onClose={() => setShowModal(false)} text={text} />
      )}
    </>
  );
};

export default ShareButton;
